import React from "react";
import Container from "src/react/layout/container";
import { Subtitle, Flex, Copy, ImageWrapper } from "./styles";
import { Section, SectionHeader } from "src/react/layout";

const imageOptions = "?fm=jpg&fl=progressive&bg=rgb:f7f7f7";
const image1 = `https://images.ctfassets.net/itvcls9imtx8/uyuyCzkCgSGyImgAWcgAM/656e28ff8bcb4e15972960aa85dbea12/our-story-1.png${imageOptions}`;
const image2 = `https://images.ctfassets.net/itvcls9imtx8/5Ik82x7dCwMA8yMsMMeeGc/11ad2d01e7cc46fdd3687461ba7c7b88/our-story-2.png${imageOptions}`;
const image3 = `https://images.ctfassets.net/itvcls9imtx8/2LWGJTbTmMQoCAWIqy4Omw/93ddb5a39e1cd506a5e7a9b99367f31f/our-story-3.png${imageOptions}`;
const image4 = `https://images.ctfassets.net/itvcls9imtx8/3XQ9JgrhFC2Y2EqsUAWA6c/b262806dc1a95c1c6c66e1c308f94076/our-story-4.png${imageOptions}`;

function OurStorySection() {
  return (
    <Container maxWidth="800px">
      <Section>
        <SectionHeader title="Our story" />
        <Flex reverse>
          <ImageWrapper>
            <img
              src={`${image1}&w=300`}
              srcSet={`${image1} 2x`}
              width={300}
              alt="Cornerstone founder"
            />
          </ImageWrapper>
          <Copy left>
            <p>
              I originally started Cornerstone from my kitchen table with a
              £5,000 loan determined to see if I could turn my idea for
              transforming mornings into a reality. I’m proud to say that from
              those humble beginnings, thanks to our fantastic team and the
              generous backing of the British public in our 2015 crowdfunding
              campaign, Cornerstone is now a thriving British success story with
              250,000 members around the UK and a long list of industry awards
              and media accolades to our name!
            </p>
            <p>
              So, in that spirit, thank you for your support and for taking a
              chance on us we may not be a big established company, but we’re
              here to listen and we really do care. If there is anything at all
              we can help with or if you think of a way we could make your
              morning even better whether it’s a new product or an improvement
              to our ‘bathroom automation’ subscription service, we’d love to
              hear from you.
            </p>
            <p>Regards,</p>
            <p>Oliver Bridge Founder</p>
          </Copy>
        </Flex>

        <SectionHeader title="Our mission" />
        <Flex>
          <ImageWrapper>
            <img
              src={`${image2}&w=300`}
              srcSet={`${image2} 2x`}
              width={300}
              alt="Amazing morning"
            />
          </ImageWrapper>
          <Copy right>
            <Subtitle>Amazing mornings for all</Subtitle>
            <p>
              We want to give you the best possible start in the morning so that
              you look and feel your best, and leave the house each day
              energised, fully-charged and ready to go!
            </p>
          </Copy>
        </Flex>

        <Flex reverse>
          <ImageWrapper>
            <img
              src={`${image3}&w=300`}
              srcSet={`${image3} 2x`}
              width={300}
              alt="The best products"
            />
          </ImageWrapper>
          <Copy left>
            <Subtitle>The Best Products</Subtitle>
            <p>
              We’ve developed each of our products in partnership with expert
              manufacturing partners giving us access to the very best
              dermatologists, engineers, chemists and nutritionists from around
              the world. It means our products are packed full of high-quality
              ingredients and can hold their own against the premium brands
              you’d find in department stores
            </p>
          </Copy>
        </Flex>

        <Flex>
          <ImageWrapper>
            <img
              src={`${image4}&w=300`}
              srcSet={`${image4} 2x`}
              width={300}
              alt="Member powered"
            />
          </ImageWrapper>
          <Copy right>
            <Subtitle>Member Powered</Subtitle>
            <p>
              We are a very people-powered business - not only did we start
              Cornerstone with crowdfunding, but we have included our members’
              feedback every step of the way to improve our service and launch
              new products. In fact, we’ve never launched a new product unless
              our members test it and absolutely love it, and we’ve been known
              to delay product launches until members are completely happy.
            </p>
          </Copy>
        </Flex>
      </Section>
    </Container>
  );
}

export default OurStorySection;
